































import Vue from "vue";

export default Vue.extend({
    name: "ContactUs",
    computed: {
        localTime: {
            cache: false,
            get(): string {
                return new Date().toLocaleString("en-US", { timeZone: "Pacific/Auckland" }).split(",")[1];
            }
        },
        USlocalTime: {
            cache: false,
            get(): string {
                return new Date().toLocaleString("en-US", { timeZone: "Pacific/Honolulu" }).split(",")[1];
            }
        }
    },
});
